import * as React from "react";

import {
  dropChatInputFocusRequest,
  requestChatInputFocus,
} from "./chatInputFocus";
import { useCollaborationBar } from "./CollaborationBarContext";

/**
 * A function that opens the chat sidebar ready for the user to type, without
 * sending anything: on the thread the bar is pointed at when it is open, else
 * on a new thread, with the cursor in the message input once the input is on
 * screen. What the page puts in the chat context, such as what is selected,
 * shows as chips above the input.
 */
export function useOpenChatToType(): () => void {
  const { isOpen, location, open } = useCollaborationBar();

  // A cursor request is kept only while the bar is open: closing the bar
  // before a message input has taken the cursor drops it, so an input that
  // mounts the next time the bar opens does not take the cursor.
  React.useEffect(() => {
    if (!isOpen) {
      dropChatInputFocusRequest();
    }
  }, [isOpen]);

  return React.useCallback(() => {
    open({
      mode: "ai-agent-chat",
      threadId: isOpen ? location.threadId : null,
      view: "thread",
    });
    requestChatInputFocus();
  }, [isOpen, location.threadId, open]);
}
